/**
 * @generated SignedSource<<04c231bf85bf2838b11d66630c1ae087>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DashboardFlightsCardUpdateStatus_settings$data = {
  readonly flightsUpdaterEnabled: boolean | null;
  readonly " $fragmentType": "DashboardFlightsCardUpdateStatus_settings";
};
export type DashboardFlightsCardUpdateStatus_settings$key = {
  readonly " $data"?: DashboardFlightsCardUpdateStatus_settings$data;
  readonly " $fragmentSpreads": FragmentRefs<"DashboardFlightsCardUpdateStatus_settings">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DashboardFlightsCardUpdateStatus_settings",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flightsUpdaterEnabled",
      "storageKey": null
    }
  ],
  "type": "Settings",
  "abstractKey": null
};

(node as any).hash = "a30618e3eae7ac25097c91813f2dc6fb";

export default node;
